(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ls-cart-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
    let pendingTitle = null;

    // "Added: <product>" – only right after Add to cart (product-form publishes before re-rendering)
    if (!customElements.get('ls-cart-added')) {
      customElements.define(
        'ls-cart-added',
        class extends HTMLElement {
          connectedCallback() {
            if (!pendingTitle) return;
            this.querySelector('[data-ls-cart-added-text]').textContent = this.dataset.template.replace(
              '[title]',
              pendingTitle
            );
            this.hidden = false;
            pendingTitle = null;
          }
        }
      );
    }

    const listen = () => {
      if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event.source !== 'product-form' || !event.cartData) return;
        pendingTitle = event.cartData.product_title || null;
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', listen);
    else listen();

    // "Pairs well with": complementary products first, otherwise related ones
    const cache = new Map();
    const load = (url) => {
      if (!cache.has(url)) {
        cache.set(
          url,
          fetch(url)
            .then((response) => response.text())
            .then((html) => {
              const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-ls-cart-pair]');
              return fresh ? fresh.outerHTML : '';
            })
            .catch(() => '')
        );
      }
      return cache.get(url);
    };

    if (!customElements.get('ls-cart-pairs')) {
      customElements.define(
        'ls-cart-pairs',
        class extends HTMLElement {
          connectedCallback() {
            const base = this.dataset.url;
            if (!base || this.dataset.loaded) return;
            this.dataset.loaded = 'true';
            load(`${base}&intent=complementary`)
              .then((html) => html || load(`${base}&intent=related`))
              .then((html) => {
                if (html && this.isConnected) this.innerHTML = html;
              });
          }
        }
      );
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ls-free-shipping-threshold"] && !Shopify.designMode) return;
  try {
    // Cart drawer and cart page are re-rendered by Dawn's scripts (innerHTML runs no inline scripts).
  // The observer callback runs as a microtask, before the next paint.
  if (window.lsShipping) {
    new MutationObserver(() => window.lsShipping.renderAll()).observe(document.body, {
      childList: true,
      subtree: true,
    });
    window.lsShipping.renderAll();
    document.addEventListener('shopify:section:load', () => window.lsShipping.renderAll());
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ls-localization-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-ls-localization-select]');
    if (select) select.form.submit();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ls-search-overlay"] && !Shopify.designMode) return;
  try {
    (() => {
    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const suggestUrl = (window.routes && window.routes.predictive_search_url) || '/search/suggest';
    const cache = new Map();
    // Elemente des aktuellen Overlays; nach einem Header-Neuladen im Theme-Editor neu gesetzt (init)
    let layer;
    let panel;
    let input;
    let results;
    let status;
    let controller;
    let timer;

    const ready = () => layer && layer.isConnected;
    const headerButton = () => document.querySelector('.ls-header__tools [data-ls-search-open]');
    const options = () => Array.from(results.querySelectorAll('[role="option"]'));
    const syncMobile = () => panel?.classList.toggle('ls-search--mobile', mobileQuery.matches);

    const setExpanded = (value) => {
      document.querySelectorAll('[data-ls-search-open]').forEach((button) => {
        button.setAttribute('aria-expanded', String(value));
      });
    };

    const setActive = (option) => {
      results.querySelector('[aria-selected="true"]')?.setAttribute('aria-selected', 'false');
      if (!option) {
        input.removeAttribute('aria-activedescendant');
        return;
      }
      option.setAttribute('aria-selected', 'true');
      input.setAttribute('aria-activedescendant', option.id);
      option.scrollIntoView({ block: 'nearest' });
    };

    const show = (html, term) => {
      // Antworten zu älteren Begriffen verwerfen (schnelles Tippen)
      if (term !== input.value.trim()) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const root = doc.querySelector('[data-ls-predictive]');
      if (!root) return;
      results.innerHTML = root.outerHTML;
      setActive(null);
      input.setAttribute('aria-expanded', String(options().length > 0));
      status.textContent = doc.querySelector('[data-ls-predictive-status]')?.textContent || '';
    };

    const clear = () => {
      controller?.abort();
      results.innerHTML = '';
      status.textContent = '';
      setActive(null);
      input.setAttribute('aria-expanded', 'false');
    };

    const search = async (term) => {
      if (cache.has(term)) {
        show(cache.get(term), term);
        return;
      }
      controller?.abort();
      controller = new AbortController();
      const params = new URLSearchParams({
        q: term,
        section_id: 'ls-predictive-search',
        'resources[type]': 'product,collection,page,query',
        'resources[limit]': '4',
        'resources[limit_scope]': 'each',
        'resources[options][fields]': 'title,product_type,variants.title,tag',
      });
      try {
        const response = await fetch(`${suggestUrl}?${params}`, { signal: controller.signal });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const html = await response.text();
        cache.set(term, html);
        show(html, term);
      } catch (error) {
        // Ein Fehler zu einem älteren Begriff darf die aktuellen Ergebnisse nicht leeren
        if (error.name !== 'AbortError' && term === input.value.trim()) clear();
      }
    };

    const position = () => {
      const header = document.querySelector('.ls-header');
      const bottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      layer.style.setProperty('--ls-search-top', `${bottom}px`);
    };

    const open = () => {
      if (!ready()) return;
      if (!layer.hidden) {
        input.focus();
        return;
      }
      position();
      layer.hidden = false;
      setExpanded(true);
      document.body.classList.add('overflow-hidden');
      input.focus();
      input.select();
      const term = input.value.trim();
      if (term.length >= 2) search(term);
    };

    const close = (restoreFocus = true) => {
      if (!ready() || layer.hidden) return;
      layer.hidden = true;
      setExpanded(false);
      setActive(null);
      input.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('overflow-hidden');
      if (restoreFocus) headerButton()?.focus();
    };

    const init = () => {
      const current = document.querySelector('[data-ls-search-layer]');
      if (!current || current.dataset.lsReady) return;
      // Header im Theme-Editor neu geladen, während das Overlay offen war: Sperre aufheben
      if (layer && !layer.hidden) {
        document.body.classList.remove('overflow-hidden');
        setExpanded(false);
      }
      clearTimeout(timer);
      controller?.abort();
      current.dataset.lsReady = 'true';
      layer = current;
      panel = layer.querySelector('.ls-search');
      input = layer.querySelector('.ls-search__input');
      results = layer.querySelector('[data-ls-search-results]');
      status = layer.querySelector('[data-ls-search-status]');
      syncMobile();

      input.addEventListener('input', () => {
        clearTimeout(timer);
        const term = input.value.trim();
        if (term.length < 2) {
          clear();
          return;
        }
        timer = setTimeout(() => search(term), 300);
      });

      input.addEventListener('keydown', (event) => {
        const list = options();
        const current = list.findIndex((option) => option.getAttribute('aria-selected') === 'true');
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          if (!list.length) return;
          event.preventDefault();
          const step = event.key === 'ArrowDown' ? 1 : -1;
          const next = current === -1 ? (step === 1 ? 0 : list.length - 1) : (current + step + list.length) % list.length;
          setActive(list[next]);
        } else if (event.key === 'Enter' && current !== -1) {
          event.preventDefault();
          list[current].click();
        }
      });


      layer.addEventListener('focusout', () => {
        setTimeout(() => {
          const active = document.activeElement;
          if (layer.hidden || layer.contains(active) || active?.closest('[data-ls-search-open]')) return;
          close(!active || active === document.body);
        });
      });
    };

    mobileQuery.addEventListener('change', syncMobile);

    // Escape schließt auch, wenn der Fokus gerade auf der Lupe im Header liegt
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !ready() || layer.hidden) return;
      event.preventDefault();
      close();
    });

    document.addEventListener('click', (event) => {
      if (!ready()) return;
      const opener = event.target.closest('[data-ls-search-open]');
      if (opener) {
        event.preventDefault();
        if (layer.hidden) open();
        else close();
        return;
      }

      const menuLink = event.target.closest('[data-ls-menu-search]');
      if (menuLink) {
        event.preventDefault();
        const dialog = menuLink.closest('dialog');
        if (dialog && dialog.open) {
          // erst nach dem Schließen öffnen, sonst holt sich der Menü-Button den Fokus zurück
          dialog.addEventListener('close', () => open(), { once: true });
          dialog.close();
        } else {
          open();
        }
        return;
      }

      if (event.target.closest('[data-ls-search-close]') || event.target.closest('[data-ls-search-backdrop]')) {
        close();
      }
    });

    window.addEventListener('resize', () => {
      if (ready() && !layer.hidden) position();
    });

    init();
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
